import { US_TIMEZONE_OPTIONS } from '@/constants/usTimezones';
import type { OptionType } from '@/ui/components/Form/Select/types';

/** US time zones, plus any extra zones (e.g. the browser's own) not already in the list. */
export function calendarTimeZoneOptions(...extraTimeZones: string[]): OptionType<string>[] {
  const options = [...US_TIMEZONE_OPTIONS];
  for (const timeZone of extraTimeZones) {
    if (!options.some((option) => option.value === timeZone)) {
      options.push({ label: timeZone, value: timeZone });
    }
  }
  return options;
}
